import React from "react";
import "./companies.scss";

const Companies = () => {
  return (
    <section id="companies">
      <div className="container">
        <img src="/images/jarocin-logo.webp" alt="" loading="lazy" />
        <img src="/images/Polsat.webp" alt="" loading="lazy" />
        <img src="/images/Zetka.webp" alt="" loading="lazy" />
        <img src="/images/winobranie.webp" alt="" loading="lazy" />
        <img src="/images/uniejow.webp" alt="" loading="lazy" />
      </div>
    </section>
  );
};

export default Companies;
